// extracted by mini-css-extract-plugin
export default {"screenCardPlaceholder":"w8wrdLlzVTIjdKkKtLgD","thumbnail":"dtvkcsSHFcrjZb6WZpGQ","info":"Mzs8MmvmssfMEk01jIOL","name":"HuLbYyyyWarP7clBS773","date":"Ket4KNS0FrYoNLo93atO"};